// React
import { ReactElement, useState } from 'react';
// Next
import { useTranslation } from 'next-i18next';
import { Image } from '@utmb/design-system/image/Image';
// Modules
import classNames from 'classnames/bind';
// Design System
// Components
import { Font } from '@utmb/design-system/text/font';
import { Slice } from '@utmb/types/slice-handler';
import { Icon } from '@utmb/design-system/icons/Icon';
// Interfaces
import { IconsEnum } from '@utmb/types/icons';
import { getRaceCategoryIcon } from '@utmb/utils/race-categories-icons';
import SliceStonesAllocationsView from '@utmb/types/view/SliceStonesAllocationsView';
import StonesAllocationView from '@utmb/types/view/StonesAllocationView';
// Styles
import styles from './stone-allocations.module.scss';
import { CloudinaryMediaView } from '@utmb/types/index';

const cx = classNames.bind(styles);

const StoneAllocationsTabs = (props: Slice<SliceStonesAllocationsView>): ReactElement => {
    const { stonesAllocationsEvent, stonesAllocationsMajor, isDark } = props;

    const { t } = useTranslation();

    const [activeIndex, setActiveIndex] = useState(0);

    const tabs = [stonesAllocationsEvent, stonesAllocationsMajor];
    const tabsLabel = ['UTMB World Series Events', 'UTMB World Series Majors'];
    const tabsIcons = ['stone_events', 'stone_majors'];

    const getStoneImage = (tab: StonesAllocationView): CloudinaryMediaView => getRaceCategoryIcon(tab.category);

    return (
        <div className={styles.sat_tabs_group}>
            <div role="tablist" aria-label={t('races.keyfigures.runningStones')}>
                {Object.keys(tabs).map((label, indexMenu: number) => (
                    <button
                        key={indexMenu}
                        className={cx(styles.sat_tab_item, {
                            sat_tab_item_active: indexMenu === activeIndex,
                            sat_tab_item_dark: isDark,
                        })}
                        onClick={() => setActiveIndex(indexMenu)}
                        aria-selected={indexMenu === activeIndex}
                        role="tab"
                        title={tabsLabel[indexMenu]}
                    >
                        <Icon variant={tabsIcons[indexMenu] as IconsEnum} />
                    </button>
                ))}
            </div>

            <div
                className={cx(styles.sat_categories_container, {
                    sat_categories_container_dark: isDark,
                })}
            >
                {tabs[0]?.map((tab, indexCategory: number) => (
                    <div key={indexCategory} className={styles.sat_maped_item}>
                        <Image layout="fill" objectFit="contain" objectPosition="center" image={getStoneImage(tab)} />
                    </div>
                ))}
            </div>

            <div className={styles.sat_separator} />

            <div
                className={cx(styles.sat_stones_container, {
                    sat_stones_container_dark: isDark,
                })}
                role="tabpanel"
            >
                {tabs[activeIndex]?.map((tab, indexStone: number) => (
                    <Font.OxaniumBold key={indexStone} mobile="16" desktop="18" className={styles.sat_maped_item}>
                        {tab.stones}
                    </Font.OxaniumBold>
                ))}
            </div>
        </div>
    );
};

export default StoneAllocationsTabs;
